import { useEffect } from 'react';

export const STICKY_HEADER_VAR = '--sticky-header-h';

// Publish the sticky header's height as --sticky-header-h; html's
// scroll-padding-top reads it so focused elements never land under the header.
// Measured (not fixed) because the toolbar is 56/48/64px by viewport and orientation.
export default function useStickyHeaderReserve(headerRef) {
  useEffect(() => {
    const header = headerRef.current;
    const style = document.documentElement.style;
    if (!header) return undefined;

    // jsdom and old browsers lack ResizeObserver; we still measure on mount and resize.
    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => sync()) : null;

    function sync() {
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0) style.setProperty(STICKY_HEADER_VAR, `${height}px`);
      else style.removeProperty(STICKY_HEADER_VAR);
    }

    if (resizeObserver) resizeObserver.observe(header);
    window.addEventListener('resize', sync);
    sync();

    return () => {
      window.removeEventListener('resize', sync);
      if (resizeObserver) resizeObserver.disconnect();
      style.removeProperty(STICKY_HEADER_VAR);
    };
  }, [headerRef]);
}
